// --- Science Direct Technology ---

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GlobalHeader } from '@sdtech/react-header-and-footer';
import GlobalFooter from '@sdtech/sd-ui/GlobalFooter';
import OrgnaizationForm from './chooseorgForm';
import SsoContainer from './ssoContainer';
import LoadingSpinner from '../ui/loadingSpinner';
import { ArrowButton } from '../../components';

import { displayOrganizations } from '../../../common/actions';

export function ChooseOrg({
  isLoading,
  showError,
  targetURL,
  adobeAnalyticsMetadata,
  submitSuccessful,
  choiceAvailable,
  displayChooseOrg,
  reactHeaderFooterConfig,
}) {
  return (
    <div className="chooseorg">
      <GlobalHeader
        config={reactHeaderFooterConfig.config}
        requestPath={reactHeaderFooterConfig.requestPath}
        isStatic={reactHeaderFooterConfig.isStatic}
      />
      <div id="sd-ai-navigation-container"></div>
      <div className="chooseorg-container auth-pages">
        <div className="chooseorg-box">
          <h1 className="chooseorg-title">Choose organization</h1>
          {showError ? (
            <div className="error-container">
              <div className="error-message">
                Sorry, your request can&apos;t be processed
                due to a system problem. Please Try again.
              </div>
              <ArrowButton type="button" onClick={displayChooseOrg}>Try Again</ArrowButton>
            </div>
          ) : ''}
          <OrgnaizationForm />
          <LoadingSpinner show={isLoading} />
          {submitSuccessful || !choiceAvailable ? (
            <SsoContainer
              targetURL={targetURL}
              adobeAnalyticsMetadata={adobeAnalyticsMetadata}
            />
          ) : ''}
        </div>
      </div>
      <GlobalFooter
        config={reactHeaderFooterConfig.config}
        requestPath={reactHeaderFooterConfig.requestPath}
      />
    </div>
  );
}

ChooseOrg.propTypes = {
  isLoading: PropTypes.bool,
  submitSuccessful: PropTypes.bool,
  choiceAvailable: PropTypes.bool,
  showError: PropTypes.bool,
  targetURL: PropTypes.string,
  adobeAnalyticsMetadata: PropTypes.object,
  displayChooseOrg: PropTypes.func,
  reactHeaderFooterConfig: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  displayChooseOrg: () => dispatch(displayOrganizations()),
});

const mapStateToProps = ({ chooseorg, config }) => ({
  ...chooseorg,
  ...config,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChooseOrg);
